/* https://popper.js.org/docs/v2/modifiers/community-modifiers/ */
/* https://codesandbox.io/s/bitter-sky-pe3z9?file=/src/index.js */
export const minWidth = {
    name: 'minWidth',
    enabled: true,
    phase: 'write',
    requires: ['computeStyles'],
    /*fn: ({ state }) => {
        //console.log('fn state', state)
        //console.log('state.rects', JSON.stringify(state.rects, null, 2))

        //console.log(JSON.stringify(state.modifiersData, null, 2))
        //state.modifiersData.minWidth.test = 1

        //console.log('state.styles.popper.width', state.styles.popper.width)
        //console.log('state.rects.reference.width', state.rects.reference.width)
        //state.styles.popper.minWidth = `${state.rects.reference.width}px`

        state.styles.popper.minWidth = `${state.rects.reference.width}px`

    },*/
    effect: ({ state }) => {
        //console.log('effect state', state)
        //console.log('state.rects', JSON.stringify(state.rects, null, 2))
        //console.log('state.rects.popper.width', state.rects.popper.width)
        //console.log('state.elements.reference.offsetWidth', state.elements.reference.offsetWidth)

        const menuContainer = state.elements.popper.querySelector('.v-menu__content')

        menuContainer.style.maxWidth = 'unset'
        menuContainer.style.width = '100%'
        //console.log(menuContainer)

        //console.log(menuContainer.offsetWidth)
        //console.log('state.elements.popper.style.width', state.elements.popper.style.width)
        //console.log('state.elements.reference.offsetWidth', state.elements.reference.offsetWidth)

        //menuContainer.style.width

        //state.modifiersData.minWidth = { menuContainer }
        state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`

        ///state.elements.popper.style.width = `${
        ///    state.elements.reference.offsetWidth
        ///}px`

        //console.log('state.elements.reference.offsetWidth', state.elements.reference.offsetWidth)


        //const existingBorderRadius = window.getComputedStyle(menuContainer).getPropertyValue('border-bottom-right-radius');

        //const existingBorderRadius = menuContainer.style.borderBottomRightRadius

        //console.log('menuContainer.style', menuContainer.style)

        //console.log('existingBorderRadius', existingBorderRadius)

        const resizeObserver = new ResizeObserver((entries) => {
            /*for (const entry of entries) {
                console.log('entry', entry)
            }*/

            //console.log('state.elements.reference.offsetWidth', state.elements.reference.offsetWidth)

            //console.log('state.elements.popper.style', state.elements.popper.style)
            state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`
            /*setTimeout(() => {
                //console.log('state.styles.popper.width after', state.styles.popper.width)
            }, 1)*/

            //console.log('Size changed')


            const widthDifference = menuContainer.offsetWidth - state.elements.reference.offsetWidth

            //if (widthDifference <= 0) return
            //console.log('popper wider than reference:', widthDifference)

            let borderRadius = 8 // 8px is set as border-bottom-*-radius in vuetify-modifications.scss
            if (widthDifference < borderRadius) {
                borderRadius = widthDifference
            }

            borderRadius = Math.max(borderRadius, 4) // 4px is set as border-top-*-radius in vuetify-modifications.scss

            menuContainer.style['border-top-right-radius'] = `${borderRadius}px`

        })

        resizeObserver.observe(state.elements.reference)

        return () => resizeObserver.unobserve(state.elements.reference)
    }
}
